<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: [''],
                    datasets: [
                        {
                            label: 'Espacio de Locales Comerciales (m²)',
                            backgroundColor: hexToRgba('#a9ff00', 70),
                            fill: true,
                            data: [49627]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                suggestedMax: 60000
                            }
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
